import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ManagerProfile = () => {
  const { managerId } = useParams();
  const navigate = useNavigate();
  
  // Profile copy aligned with belairemechanical.com management bios
  const managersData = {
    1: {
      id: 1,
      name: 'Jim  Dinan',
      title: 'President / CEO / Owner',
      image: '/images/management/JimDinanEdit1.png',
      bio: 'Jim has been involved in the HVAC industry for 35 years. His experience includes industrial, institutional, commercial, mission critical, and hospital/healthcare mechanical construction. As President and Chief Executive Officer of Bel-Aire Mechanical, his daily duties include corporate administration, corporate marketing, client development, contract administration, design development, senior consulting, and preconstruction administration.',
      experience: [
        '35 years in the HVAC industry across major market sectors',
        'Hands-on background in industrial, institutional, commercial, mission critical, and healthcare work',
        'Corporate administration, marketing, and client development',
        'Contract administration, design development, and senior consulting',
        'Preconstruction administration and executive leadership'
      ],
      education: [
        'Ongoing executive and industry leadership development in mechanical contracting'
      ],
      certifications: [
        'Leadership focused on safe, quality delivery of complex mechanical systems'
      ],
      responsibilities: [
        'Overall company direction and executive decision making',
        'Client development and senior-level consulting',
        'Contract and preconstruction oversight',
        'Alignment of Bel-Aire Mechanical with customer and industry expectations'
      ]
    },
    2: {
      id: 2,
      name: 'Nick Ganem',
      title: 'Vice President',
      image: '/images/management/NickGanem_01.png',
      bio: 'Nick\'s career in the HVAC industry spans nearly 40 years. In addition to his duties at Bel-Aire, Nick serves on three industry boards, including SMACNA Arizona (the Arizona chapter of the Sheet Metal and Air Conditioning Contractors National Association) and as a trustee on two pension, health and welfare funds. Nick is a member of the International Foundation of Employee Benefit Plans, P.I.P.E. (Piping Industry Progress and Education Trust Fund), and PAC (Plumbing and Air Conditioning Contractors).',
      experience: [
        'Nearly 40 years in the HVAC industry',
        'Vice President responsibilities supporting Bel-Aire Mechanical operations and relationships',
        'Board service with SMACNA Arizona and trustee roles on pension, health, and welfare funds',
        'Active participation in industry benefit, education, and contractor organizations'
      ],
      education: [
        'Phoenix College',
        'Maricopa Technical College'
      ],
      certifications: [
        'Member, International Foundation of Employee Benefit Plans',
        'Member, Piping Industry Progress & Education (P.I.P.E.)',
        'Member, Plumbing and Air Conditioning Contractors (PAC)'
      ],
      responsibilities: [
        'Executive leadership and industry representation',
        'Support for company strategy, labor relations, and benefit-plan governance',
        'Engagement with owners, partners, and trade organizations',
        'Advocacy for workforce training and industry standards'
      ]
    },
    3: {
      id: 3,
      name: 'Michelle Dinan-Cardone',
      title: 'Executive Administrator',
      image: '/images/management/MichelleDinanCardone_01.png',
      bio: 'Michelle Dinan-Cardone serves as Executive Administrator for Bel-Aire Mechanical, supporting the president and leadership team with corporate administration, scheduling, and internal coordination so day-to-day operations run smoothly for staff and clients.',
      experience: [
        'Executive and administrative support for senior leadership',
        'Coordination of corporate schedules, meetings, and communications',
        'Interface with internal teams and external partners on administrative matters',
        'Organization of office operations that underpin service and construction activity'
      ],
      education: [
        'Professional development in executive administration and office management'
      ],
      certifications: [
        'Focus on confidentiality, accuracy, and responsive support for leadership'
      ],
      responsibilities: [
        'Administrative support for the President / CEO and executive team',
        'Corporate correspondence, scheduling, and document coordination',
        'Support for special projects and leadership initiatives',
        'Maintaining efficient office workflows across departments'
      ]
    },
    4: {
      id: 4,
      name: 'Drew Schroder',
      title: 'Construction Director',
      image: '/images/management/DrewSchroder_01.png',
      bio: 'Drew has 40 years of piping, plumbing, and sheet metal experience in the HVAC industry. His management and supervisory skills have been used in every phase of the construction industry, including laboratory and hospital, electronics and industrial manufacturing, clean rooms, schools, office buildings, apartments, and universities throughout Arizona. Drew is responsible for labor management, scheduling, coordination, and buyout of materials for sheet metal, piping, and plumbing on the project.',
      experience: [
        '40 years in piping, plumbing, and sheet metal within the HVAC industry',
        'Supervisory and management roles across the full construction lifecycle',
        'Project types including healthcare, industrial, clean rooms, education, offices, and multifamily',
        'Statewide Arizona experience coordinating trades and project resources'
      ],
      education: [
        'Extensive field and leadership training across mechanical construction trades'
      ],
      certifications: [
        'Emphasis on safe, coordinated delivery of mechanical scopes in the field'
      ],
      responsibilities: [
        'Labor management, scheduling, and coordination for mechanical construction',
        'Buyout and coordination of sheet metal, piping, and plumbing materials',
        'Alignment of field execution with project schedules and quality goals',
        'Leadership of construction teams on complex commercial and institutional work'
      ]
    },
    5: {
      id: 5,
      name: 'Sabino Nieto',
      title: 'Project Director',
      image: '/images/management/SabinoNieto_01.png',
      bio: 'Sabino is a highly knowledgeable senior project manager who has been in the industry since 1998. Notable experience includes semiconductor, mission critical, pharmaceutical, and food processing projects across Arizona, Texas, and Mexico. As Project Director, he coordinates multiple projects from start to finish, working with estimating, BIM, QA/QC, the general contractor, and the owner to clarify design and scope, manage cost and productivity, oversee quality control, and keep projects on schedule and within budget—including billings, schedules, and change orders.',
      experience: [
        'Senior project management since 1998 across Arizona, Texas, and Mexico',
        'Semiconductor, mission critical, pharmaceutical, and food processing sectors',
        'Coordination with owners, engineers, general contractors, and trades for quality installations',
        'Multi-million dollar project leadership with strong communication and technical depth'
      ],
      education: [
        'Career-long development in HVAC, mechanical, and plumbing construction delivery'
      ],
      certifications: [
        'Hands-on leadership in BIM coordination, estimating interfaces, and QA/QC processes'
      ],
      responsibilities: [
        'Overall coordination of multiple projects from start to finish',
        'Scope and design clarification with estimating, BIM, and QA/QC representatives',
        'Cost control, productivity measurement, schedule adherence, and quality oversight',
        'Management of billings, schedules, and change orders to meet client expectations'
      ]
    },
    6: {
      id: 6,
      name: 'Robert Dustman',
      title: 'Project Director',
      image: '/images/management/RobertDustman_01.png',
      bio: 'Robert Dustman joined Bel-Aire Mechanical in 2009 and serves as Project Director. He has more than 37 years of hands-on experience in the design, development, and construction of HVAC and plumbing systems, with a diverse background in sheet metal, mechanical piping, plumbing, and medical gas. Robert is known as a high-energy, service-oriented professional with a proven record across healthcare, heavy commercial, manufacturing, and entertainment facilities, responsible for the project from inception through completion.',
      experience: [
        'Bel-Aire Mechanical team member since 2009',
        'More than 37 years in HVAC and plumbing design, development, and construction',
        'Technical and managerial background in sheet metal, piping, plumbing, and medical gas',
        'Project leadership across healthcare, commercial, manufacturing, and entertainment'
      ],
      education: [
        'Deep practical training across mechanical design and field installation'
      ],
      certifications: [
        'Commitment to value-driven delivery and long-term client success'
      ],
      responsibilities: [
        'Project direction from inception through closeout',
        'Oversight of mechanical system quality, coordination, and schedule',
        'Leadership of project teams serving complex facility types',
        'Single-point accountability for mechanical scope execution and client communication'
      ]
    },
    7: {
      id: 7,
      name: 'John McIntyre',
      title: 'Preconstruction Manager / Chief Estimator',
      image: '/images/management/JohnMcIntyre_01.png',
      bio: 'John McIntyre brings more than 23 years of construction industry experience in Arizona, with expertise in HVAC, plumbing, medical gas, and process piping. He estimates mechanical systems from conceptual design through final construction documents. John works closely with owners and design professionals to establish budgets and provide value engineering that saves clients time and money, with extensive experience in hospitals, laboratories, pharmaceutical, semiconductor, and manufacturing facilities.',
      experience: [
        'More than 23 years in Arizona construction estimating and preconstruction',
        'Mechanical estimating from conceptual design through final construction documents',
        'HVAC, plumbing, medical gas, and process piping systems',
        'Healthcare, laboratory, pharmaceutical, semiconductor, and manufacturing projects'
      ],
      education: [
        'Applied training in mechanical estimating, design coordination, and value engineering'
      ],
      certifications: [
        'Recognized for clear communication, relationship building, and follow-through with owners and designers'
      ],
      responsibilities: [
        'Chief estimating and preconstruction leadership',
        'Budget development and value engineering with owners and design teams',
        'Evaluation of scope, risk, and constructability for major mechanical packages',
        'Support for successful transitions from preconstruction into construction'
      ]
    },
    8: {
      id: 8,
      name: 'Greg Era',
      title: 'IT Manager',
      image: '/images/management/GregEra_01.png',
      bio: 'Greg Era leads information technology for Bel-Aire Mechanical, keeping business systems, networks, and applications reliable for office staff, project teams, and field operations across service and construction.',
      experience: [
        'IT leadership supporting a mechanical contractor’s daily operations',
        'Infrastructure and systems that connect estimating, BIM, accounting, and field tools',
        'User support, troubleshooting, and coordination with vendors and internal stakeholders',
        'Focus on uptime, security, and practical technology adoption for construction teams'
      ],
      education: [
        'Continuing education in information systems, cybersecurity, and construction technology'
      ],
      certifications: [
        'Alignment of IT services with Bel-Aire Mechanical business and safety requirements'
      ],
      responsibilities: [
        'Management of servers, networks, endpoints, and business applications',
        'Support for software used in estimating, BIM/VDC, and project delivery',
        'Data protection, backups, and access control in line with company policy',
        'Help-desk leadership and technology planning for growth and reliability'
      ]
    },
    9: {
      id: 9,
      name: 'Brandon Sonju',
      title: 'Service Ops Manager',
      image: '/images/management/BrandonSonju_01.png',
      bio: 'Brandon Sonju has been working in the HVAC industry for more than 20 years. In 2011 he joined Bel-Aire Mechanical as Service Operations Manager and has helped establish and grow the service team into a premier mission critical, industrial, and commercial HVAC service organization.',
      experience: [
        'More than 20 years in the HVAC industry',
        'Service Operations Manager at Bel-Aire Mechanical since 2011',
        'Growth of the service team serving mission critical, industrial, and commercial clients',
        'Leadership of service workflows, dispatch alignment, and customer delivery'
      ],
      education: [
        'Trade and industry training supporting commercial and industrial HVAC service'
      ],
      certifications: [
        'HVAC Service Contractors of America',
        'HVAC Professionals',
        'Piping Industry Progress & Education (P.I.P.E.)'
      ],
      responsibilities: [
        'Oversight of service operations and field team performance',
        'Alignment of service resources with customer uptime and contract requirements',
        'Development of processes that support 24/7 and mission critical response',
        'Coordination with leadership on staffing, training, and service quality'
      ]
    },
    10: {
      id: 10,
      name: 'Ken Groll',
      title: 'Service Manager',
      image: '/images/management/KenGroll_01.png',
      bio: 'Ken Groll has been with Bel-Aire Mechanical since 2017. He began his HVAC trade in 1988 in residential work and moved into commercial and industrial service. His background includes roles with a leading OEM manufacturer—Service Mechanic, National Service Foreman, and Service Manager. At Bel-Aire he holds a key leadership role in the Service Department and is responsible for day-to-day operations, customer support, and field support.',
      experience: [
        'Bel-Aire Mechanical since 2017',
        'HVAC trade experience since 1988, from residential through commercial and industrial',
        'Prior OEM roles: Service Mechanic, National Service Foreman, and Service Manager',
        'Day-to-day leadership of service operations, customers, and field teams'
      ],
      education: [
        'Progressive trade and manufacturer-level training in HVAC service and leadership'
      ],
      certifications: [
        'C.A.S.H.E',
        'Piping Industry Progress & Education (P.I.P.E.)',
        'UA Local 469'
      ],
      responsibilities: [
        'Service Department operations, scheduling, and technician support',
        'Customer and field support for commercial and industrial accounts',
        'Coordination with dispatch and operations leadership',
        'Mentoring and technical guidance for service mechanics and foremen'
      ]
    },
    11: {
      id: 11,
      name: 'Brandon Henderson',
      title: 'BIM Director',
      image: '/images/management/BrandonHenderson_01.png',
      bio: 'Brandon is a member of Arizona Sheet Metal Local 359 and has been in mechanical construction for more than 16 years, including more than 12 years at Bel-Aire Mechanical. He performs HVAC design and construction coordination for mission critical facilities, data centers, healthcare, microelectronics, education, offices, and laboratories. Brandon leads BIM and virtual construction using current fabrication MEP tools, Navisworks, Revit, Bluebeam, Autodesk products, and TRIMBLE and HILTI total stations for layout and surveying, providing collision detection and resolution across mechanical, plumbing, electrical, and fire protection disciplines.',
      experience: [
        'More than 16 years in mechanical construction; more than 12 years with Bel-Aire Mechanical',
        'Member, Arizona Sheet Metal Local 359',
        'BIM/VDC for mission critical, data center, healthcare, microelectronics, and lab projects',
        'Coordination and clash resolution across MEP/FP with Fabrication MEP, Navisworks, and Revit'
      ],
      education: [
        'Applied training in BIM, virtual construction, and field layout technologies'
      ],
      certifications: [
        'TRIMBLE and HILTI total station workflows for point layout and surveying',
        'Advanced use of Autodesk and Microsoft platforms for model-based delivery'
      ],
      responsibilities: [
        'Direction of BIM and virtual design and construction for the company',
        'Modeling and coordination of HVAC ductwork and piping/plumbing systems',
        'Leadership of clash detection and multidisciplinary coordination',
        'Support for preconstruction, fabrication, and field installation accuracy'
      ]
    },
    12: {
      id: 12,
      name: 'Scott Kienast',
      title: 'Safety Director',
      image: '/images/management/ScottKienast_01.png',
      bio: 'Scott brings more than 32 years of safety and health, industrial hygiene, loss control, emergency response, and hazardous waste management experience. He is a problem solver with strong accomplishments in safety management, health and environmental supervision, and professional certifications. At Bel-Aire Mechanical he develops and facilitates new employee orientation, safety training, drug screening, return-to-work programs, job hazard analysis, accident investigation, SDS programs, and environmental inspections, with deep knowledge of OSHA, BATF, NRC, DOT, FAA, and EPA rules.',
      experience: [
        'More than 32 years in safety, industrial hygiene, loss control, and emergency response',
        'Hazardous waste management and environmental health supervision',
        'Program development: orientation, training, drug screening, return-to-work, JHA, and investigations',
        'Interpretation of OSHA, BATF, NRC, DOT, FAA, and EPA requirements'
      ],
      education: [
        'Professional development across occupational safety, industrial hygiene, and environmental compliance'
      ],
      certifications: [
        'Professional safety and industrial hygiene credentials supporting director-level responsibilities'
      ],
      responsibilities: [
        'Establish and maintain safety relationships with employees and clients',
        'Monitor industry practices and keep Bel-Aire’s safety program effective',
        'Prepare and deliver safety training and supervisor best-practice coaching',
        'Keep safety visible, investigate incidents, and reinforce management’s commitment to safe work'
      ]
    }
  };

  // Get manager data based on ID, fallback to default if not found
  const managerData = managersData[managerId] || {
    id: managerId,
    name: 'Manager Name',
    title: 'Position Title',
    image: '/images/management/default.jpg',
    bio: 'This manager\'s profile information is being updated. Please check back soon for complete details about their background and responsibilities.',
    experience: ['Profile information coming soon'],
    education: ['Education details coming soon'],
    certifications: ['Certification details coming soon'],
    responsibilities: ['Responsibility details coming soon']
  };

  return (
    <div className="page-content">
      {/* Hero Section */}
      <section className="page-hero manager-profile-hero" style={{
        position: 'relative',
        backgroundImage: `url(${managerData.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center 19%',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden'
      }}>
        {/* Gradient Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(37deg, rgba(0, 104, 166, 0.85) 0%, rgba(0, 104, 166, 0.85) 48%, rgba(171, 22, 54, 0.85) 52%, rgba(171, 22, 54, 0.85) 100%)',
          zIndex: 1
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 2}}>
          <h1 className="manager-profile-name" style={{color: 'var(--white)', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)'}}>{managerData.name}</h1>
          <p className="manager-profile-title-hero" style={{color: 'rgba(255, 255, 255, 0.95)', fontSize: '1.3rem', textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)'}}>{managerData.title}</p>
        </div>
      </section>

      {/* Back to Management Button */}
      <section className="section" style={{paddingTop: '2rem', paddingBottom: '1rem'}}>
        <div className="container">
          <button 
            onClick={() => navigate('/management')}
            style={{
              background: 'var(--accent-blue)',
              color: 'var(--white)',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              fontSize: '1rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'var(--accent2-red)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'var(--accent-blue)';
            }}
          >
            <span className="material-icons" style={{fontSize: '1.2rem'}}>arrow_back</span>
            Back to Management Team
          </button>
        </div>
      </section>

      {/* Manager Profile Content */}
      <section className="section">
        <div className="container">
          <div className="manager-profile-grid" style={{display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '3rem', alignItems: 'start'}}>
            {/* Manager Photo */}
            <div>
              <div 
                className="manager-profile-image" 
                style={{
                  width: '100%',
                  height: '400px',
                  borderRadius: '12px',
                  backgroundImage: `url(${managerData.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'top center',
                  backgroundRepeat: 'no-repeat',
                  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)'
                }}
              >
              </div>
            </div>

            {/* Manager Information */}
            <div className="manager-profile-info">
              <h2 className="manager-profile-info-name" style={{fontSize: '2rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>
                {managerData.name}
              </h2>
              <h3 className="manager-profile-info-title" style={{fontSize: '1.3rem', color: 'var(--accent2-red)', marginBottom: '2rem'}}>
                {managerData.title}
              </h3>
              
              <p className="manager-profile-bio" style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                {managerData.bio}
              </p>

              {/* Experience */}
              <div style={{marginBottom: '2rem'}}>
                <h4 className="manager-profile-section-title" style={{fontSize: '1.2rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Experience</h4>
                <ul className="manager-profile-list" style={{listStyle: 'none', padding: 0}}>
                  {managerData.experience.map((exp, index) => (
                    <li key={index} style={{
                      padding: '0.5rem 0',
                      borderBottom: '1px solid var(--secondary-light)',
                      fontSize: '1rem',
                      color: 'var(--gray-600)'
                    }}>
                      <span style={{color: 'var(--accent-blue)', marginRight: '0.5rem'}}>•</span>
                      {exp}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Education */}
              <div style={{marginBottom: '2rem'}}>
                <h4 className="manager-profile-section-title" style={{fontSize: '1.2rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Education</h4>
                <ul className="manager-profile-list" style={{listStyle: 'none', padding: 0}}>
                  {managerData.education.map((edu, index) => (
                    <li key={index} style={{
                      padding: '0.5rem 0',
                      borderBottom: '1px solid var(--secondary-light)',
                      fontSize: '1rem',
                      color: 'var(--gray-600)'
                    }}>
                      <span style={{color: 'var(--accent-blue)', marginRight: '0.5rem'}}>•</span>
                      {edu}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Certifications */}
              <div style={{marginBottom: '2rem'}}>
                <h4 className="manager-profile-section-title" style={{fontSize: '1.2rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Certifications</h4>
                <ul className="manager-profile-list" style={{listStyle: 'none', padding: 0}}>
                  {managerData.certifications.map((cert, index) => (
                    <li key={index} style={{
                      padding: '0.5rem 0',
                      borderBottom: '1px solid var(--secondary-light)',
                      fontSize: '1rem',
                      color: 'var(--gray-600)'
                    }}>
                      <span style={{color: 'var(--accent-blue)', marginRight: '0.5rem'}}>•</span>
                      {cert}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Responsibilities */}
              <div>
                <h4 className="manager-profile-section-title" style={{fontSize: '1.2rem', color: 'var(--accent-blue)', marginBottom: '1rem'}}>Key Responsibilities</h4>
                <ul className="manager-profile-list" style={{listStyle: 'none', padding: 0}}>
                  {managerData.responsibilities.map((resp, index) => (
                    <li key={index} style={{
                      padding: '0.5rem 0',
                      borderBottom: '1px solid var(--secondary-light)',
                      fontSize: '1rem',
                      color: 'var(--gray-600)'
                    }}>
                      <span style={{color: 'var(--accent-blue)', marginRight: '0.5rem'}}>•</span>
                      {resp}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ManagerProfile;
